var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8ThumbsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.9,19.5c-0.9-1-2.1-1.5-3.4-1.5h-9.2c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.2-0.1-0.4,0-0.6c0.8-1.8,1.3-3.4,1.7-5.4 C25.9,10.7,26,10,26,9.3c0-2.9-2.2-4-3.3-4.2c-0.2,0-0.4,0-0.5,0.2c-0.1,0.1-6.4,9.2-8.9,11.7c-2.1,2-3.3,4.5-3.3,7v6.6 C10,36.3,14.7,41,20.5,41h9.3c3.3,0,6-2.4,6.5-5.7L38,23.1C38.2,21.8,37.8,20.5,36.9,19.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8ThumbsUp);
export default __webpack_public_path__ + "static/media/icons8-thumbs-up.c2a95f2404c1c9a12f19ae3486443d3f.svg";
export { ForwardRef as ReactComponent };